import { computeInventoryAppearanceHash, entityHeldObjectSpriteId } from "game-common/item/item"
import type { Entity } from "game-common/models"
import type { ClientRenderable } from "./entity_rendering_manager"
import { FireSprite } from "./sprites/fire_sprite"

type ArtworkState = Partial<Pick<Entity, "spriteId" | "expirationTs" | "quantity" | "landedArrow">>

/** Visual changes shared by active entities and entities viewed on another floor. */
export const updateEntityArtwork = (
    sprite: ClientRenderable, entity: ArtworkState & Pick<Entity, "rainDamaged">, previous: ArtworkState,
): ArtworkState => {
    if (previous.spriteId !== entity.spriteId) sprite.updateSpriteId?.(entity.spriteId)
    if (previous.expirationTs !== entity.expirationTs || previous.landedArrow !== entity.landedArrow)
        sprite.updateRotating?.(!entity.landedArrow && entity.expirationTs !== undefined)
    if (previous.quantity !== entity.quantity) sprite.updateName?.(entity.quantity > 1 ? `${entity.quantity}` : "")
    if (sprite instanceof FireSprite) sprite.setSputtering(!!entity.rainDamaged)
    return { spriteId: entity.spriteId, expirationTs: entity.expirationTs, quantity: entity.quantity, landedArrow: entity.landedArrow }
}

/** Both views must rebuild a body for the same equipment, held-object and water changes. */
export const entityAppearanceKey = (entity: Entity): string => (
    `${entity.submerged}-` +
    `${entity?.weapon?.weaponType}-` +
    `${entity?.appearance?.race}-` +
    `${entity?.appearance?.sex}-` +
    `${entity?.appearance?.hair}-` +
    `${entity?.appearance?.hairColor}-` +
    `${entity?.appearance?.inventoryAppearanceHash}-` +
    `${entity?.appearance?.emberSprite}-` +
    // Equipment can arrive after appearance, without changing the server's appearance hash.
    `${computeInventoryAppearanceHash(entity.inventory)}-` +
    `${entityHeldObjectSpriteId(entity)}`
)
